import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-[#FFF8EC] min-h-screen xl:pt-32 pt-24 px-6">
      <div className=" mx-auto  p-8  rounded-lg">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <p className="text-gray-700 mb-6">
          Welcome to Net4Surge! We are committed to protecting your privacy and ensuring that your personal information is handled securely and responsibly.
        </p>
        
        <div className="space-y-8">
          {sections.map((section :any, index : any) => (
            <Section key={index} title={section.title} content={section.content} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Section = ({ title, content } : any) => (
  <section>
    <h2 className="text-2xl font-semibold text-left pb-2 text-gray-800 mb-2">{title}</h2>
    {Array.isArray(content) ? (
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        {content.map((item : any, index : any) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    ) : (
      <p className="text-gray-700">{content}</p>
    )}
  </section>
);

const sections = [
  {
    title: '1. Information We Collect',
    content: [
      <strong>Information You Provide:</strong>, ' Business details, personal details, payment details, reviews, feedback.',
      <strong>Information We Collect Automatically:</strong>, ' IP address, device type, browser information, usage data, cookies.',
      <strong>Information from Third-Party Sources:</strong>, ' Publicly available business data, social media profiles.'
    ]
  },
  {
    title: '2. How We Use Your Information',
    content: [
      'To create and manage your business listing.',
      'To improve and personalize your user experience.',
      'To communicate updates, promotions, and support.',
      'To verify business listings and enhance security.',
      'To comply with legal and regulatory obligations.'
    ]
  },
  {
    title: '3. How We Share Your Information',
    content: [
      <strong>With Other Users:</strong>, ' Your business details will be publicly visible.',
      <strong>With Third-Party Service Providers:</strong>, ' For analytics, payments, and marketing.',
      <strong>For Legal Compliance:</strong>, ' If required by law or to protect our platform.'
    ]
  },
  {
    title: '4. Data Security',
    content: 'We implement security measures including secure servers, encryption, limited access, and regular audits.'
  },
  {
    title: '5. Your Rights & Choices',
    content: [
      'Access & Update: You can update or delete your business details anytime.',
      'Opt-out: Unsubscribe from marketing emails.',
      'Data Deletion: Request removal of personal data.',
      'To exercise these rights, contact us at support@net4surge.com.'
    ]
  },
  {
    title: '6. Cookies & Tracking Technologies',
    content: 'We use cookies to enhance user experience, remember preferences, and track performance. You can manage cookie preferences in your browser settings.'
  },
  {
    title: '7. Third-Party Links',
    content: 'Our platform may contain links to external websites. We are not responsible for their privacy practices. Please review their privacy policies.'
  },
  {
    title: '8. Changes to This Privacy Policy',
    content: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.'
  },
  {
    title: '9. Contact Us',
    content: [
      '📧 Email: support@net4surge.com',
      '📍 Address: A67, Sector 2 Noida UP- 201301'
    ]
  }
];

export default PrivacyPolicy;
